import { jsx as _jsx } from "react/jsx-runtime";
import { FullSkeleton } from '../common/FullSkeleton';
import NetworkListCard from './Card/NetworkListCard';
function NetworkListView(props) {
    const { contextCustomer } = props;
    return contextCustomer ? _jsx(NetworkListCard, {}) : _jsx(FullSkeleton, {});
}
export default NetworkListView;
